export const emptyArray = []

export const emptyObject = {}
